import React, { ChangeEvent } from 'react';
import useStyle from './labelInput.style';

interface LabelInputProps {
  label: string;
  value?: string;
  name: string;
  placeHolder: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  error?: string;
  type?: 'text' | 'tel' | 'email' | 'password';
}

export const LabelInput = ({
  label,
  name,
  value,
  placeHolder,
  onChange,
  required = false,
  error,
  type = 'text'
}: LabelInputProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <p className={classes.label}>{label}</p>
      <input
        className={classes.input}
        name={name}
        placeholder={placeHolder}
        type={type}
        onChange={onChange}
        defaultValue={value}
        required={required}
      />
      {error && <p className={classes.inputError}>{error}</p>}
    </div>
  );
};
